import { Component, inject, Input, OnInit } from '@angular/core';
import { BasicForm } from '@shared/components/classes/basic.form';
import { DefaultService } from '@common/references/default.service';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AutocompleteComponent } from '@shared/components/autocomplete/autocomplete.component';
import { CalendarModule } from '@primeng/calendar';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { EmptyResultComponent } from '@shared/components/empty-result/empty-result.component';
import { FullNamePipe } from '@common/pipe/full-name.pipe';
import { InputValidatorDirective } from '@common/directive/input-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { ResidentsService } from '@modules/universal-billing/residents/residents.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-renter-withdraw',
  standalone: true,
  imports: [
    AutocompleteComponent,
    CalendarModule,
    DatePipe,
    EmptyResultComponent,
    FullNamePipe,
    InputValidatorDirective,
    ReactiveFormsModule,
    TitleCasePipe,
    TranslatePipe
  ],
  templateUrl: './renter-withdraw.component.html',
  styleUrl: './renter-withdraw.component.scss'
})
export class RenterWithdrawComponent extends BasicForm<any> implements OnInit {
  @Input({ required: true }) apartmentId: number;
  @Input({ required: true }) renterId: number;

  _defaultService: ResidentsService = inject(ResidentsService);

  form: FormGroup = new FormGroup({
    residentId: new FormControl(null, Validators.required),
    apartmentId: new FormControl(null, Validators.required),
    endDate: new FormControl(null, Validators.required),
  });
  dateFields = ['endDate'];

  ngOnInit(): void {
    this.form.patchValue({
      residentId: this.renterId,
      apartmentId: this.apartmentId,
    })
  }
  submitAction(data: object): Observable<any> {
    return this._defaultService.withdraw(data);
  }
}
